import { render, staticRenderFns } from "./AddRestaurantModal.vue?vue&type=template&id=ae0983c2"
import script from "./AddRestaurantModal.vue?vue&type=script&lang=ts"
export * from "./AddRestaurantModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports